enum LembreteEnum {
  Normal = 'Normal',
  Alerta = 'Alerta',
  Critico = 'Critico',
}

export default LembreteEnum
